import { string } from 'yup';
import { ValidationConfigPL } from '@/src/lib/validation/validation.config';
import { RegisterFormValidationModel } from '@/src/lib/validation/models/register-form-validation.model';
import { getZipCodeMessage, getMaxLengthMessage } from '@/src/lib/dictionary/utils';

export class RegisterFormValidationModelPL extends RegisterFormValidationModel {
  public get zipCode() {
    const fieldName = this.DICT.userProfile.userData.postcode;
    const maxLength = ValidationConfigPL.ZIP_MAX_LENGTH;

    return string()
      .required(this.REQUIRED_MESSAGE)
      .matches(ValidationConfigPL.ZIP_REGEX, getZipCodeMessage(this.DICT, this.TENANT_CONFIG.zipCodeExample.default))
      .length(ValidationConfigPL.ZIP_MAX_LENGTH, getMaxLengthMessage(fieldName, maxLength, this.DICT))
      .trim();
  }

  public get region() {
    return string().nonNullable().required(this.REQUIRED_MESSAGE);
  }
}
